import SlideThumbnail from './SlideThumbnail';
import SlideThumbnailSortable from './sortable';

export { SlideThumbnail };

export default SlideThumbnailSortable;
